import { useMutation } from "@tanstack/react-query";
import submitFieldValue from "../../controllers/appointments/submit-field";

const usePushAptFieldToAptV2 = () => {
  return useMutation(submitFieldValue, {});
};

export default usePushAptFieldToAptV2;
